import { all, call, put, takeLatest } from 'redux-saga/effects';
import _ from 'lodash';
import { orgId, Ajax, contactIdPrivate, qs } from 'utils';
import { getParam } from '../../utils/ebUtils';
import * as actionTypes from '../actions/actionTypes';
import * as signUpActions from '../actions/signUpActions';

export function* getSubscriptions({ payload: { accountId } }) {
  try {
    const url = `/${orgId}/${accountId}/subscriptions`;
    const { data: result } = yield call(Ajax.get, url);
    yield put(signUpActions.getSubscriptions.success(result));
  } catch (error) {
    yield put(signUpActions.getSubscriptions.fail(error));
  }
}

export function* getCurrentUserInit() {
  try {
    const initUrl = `/rest/init?orgId=${orgId}`;
    const accountUrl = `/rest/init/account?orgId=${orgId}`;
    const [initData, accountData] = yield all([
      call(Ajax.get, initUrl),
      call(Ajax.get, accountUrl)
    ]);
    const result = {
      account: accountData.data,
      ...initData.data
    };
    const accountId = _.get(result, 'account.id', 0);
    const accountName = _.get(result, 'account.name', '');
    const payload = {
      accountId,
      accountName,
    };
    yield put(signUpActions.getCurrentUserInit.success(payload));
  } catch (error) {
    yield put(signUpActions.getCurrentUserInit.fail(error));
  }
}

export function* getSettings() {
  try {
    const url = `/rest/registration/settings?orgId=${orgId}`;
    const { data: payload } = yield call(Ajax.get, url);
    yield put(signUpActions.getSettings.success(payload));
  } catch (error) {
    yield put(signUpActions.getSettings.fail(error));
  }
}

export function* createAccount({ payload: { data, callback, fetchInitData, privateContactId } }) {
  try {
    let url;
    if (privateContactId) {
      const referrer = getParam('referrer') || '';
      const params = new URLSearchParams(referrer);
      const strOrgId = params.get('orgId');
      const strContactId = params.get('contactId');
      const time = params.get('time');
      const key = params.get('key');
      url = `/rest/registration/signUp?orgId=${orgId}&contactId=${privateContactId}&strOrgId=${strOrgId}&strContactId=${strContactId}&time=${time}&key=${key}`;
    } else {
      url = `/rest/registration/signUp?orgId=${orgId}`;
    }
    const {
      data: { contactId, CSRF_TOKEN_FOR_SESSION, errorCode },
      status,
    } = yield call(Ajax.post, url, data, { isSignUp: true });
    if (status === 200) {
      yield call(fetchInitData);
      yield put(
        signUpActions.createAccount.success({
          contactId,
          CSRF_TOKEN_FOR_SESSION,
        }),
      );
      callback();
    } else {
      yield put(signUpActions.createAccount.fail({ signUpError: errorCode }));
      callback();
    }
  } catch (error) {
    yield put(signUpActions.createAccount.fail(error));
  }
}

export function* createAccountForPublicOrg({ payload: { data, callback, fetchInitData } }) {
  try {
    const url = '/mbr-portal/api/v1/register';
    console.log('url', url)
    const {
      data: { individualAccountId, CSRF_TOKEN_FOR_SESSION, errorCode },
      status,
    } = yield call(Ajax.post, url, data, { isSignUp: true });
    if (status === 200) {
      yield call(fetchInitData);
      yield put(
        signUpActions.createAccountForPublicOrg.success({
          individualAccountId,
          CSRF_TOKEN_FOR_SESSION,
        }),
      );
      callback();
    } else {
      yield put(signUpActions.createAccountForPublicOrg.fail({ signUpError: errorCode }));
      callback();
    }
  } catch (error) {
    yield put(signUpActions.createAccountForPublicOrg.fail(error));
  }
}

export function* withinGeoFence({ payload: { data, callback } }) {
  try {
    const url = `/${orgId}/addresses/withinGeoFence?longitude=0&latitude=0`;
    const { data: result, status, errorCode } = yield call(Ajax.get, url, data);
    if (status === 200) {
      yield put(signUpActions.withinGeoFence.success({ result }));
      callback();
    } else {
      yield put(signUpActions.withinGeoFence.fail({ withinGeoFenceError: errorCode }));
      callback();
    }
  } catch (error) {
    yield put(signUpActions.withinGeoFence.fail({ errorinfo: 'withinGeoFenceError' }));
  }
}

export function* getPrivateUserInfo({ payload: { data, callback } }) {
  try {
    const url = `/rest/registration/userInfo?orgId=${orgId}&contactId=${contactIdPrivate}`;
    const { data: privateUserInfo, status, errorCode } = yield call(Ajax.get, url, data);
    if (status === 200) {
      yield put(signUpActions.getPrivateUserInfo.success({ privateUserInfo }));
      callback();
    } else if (status === 404 || status === 400) {
      yield put(signUpActions.getPrivateUserInfo.fail({ getPrivateUserInfoError: 'Failed to get specified user information' }));
      callback();
    } else {
      yield put(signUpActions.getPrivateUserInfo.fail({ getPrivateUserInfoError: errorCode }));
      callback();
    }
  } catch (error) {
    yield put(signUpActions.getPrivateUserInfo.fail({ errorinfo: 'getPrivateUserInfoError' }));
  }
}

export function* getAsIsState({ payload }) {
  try {
    yield put(signUpActions.getAsIsState.success({ payload }));
  } catch (error) {
    console.error(error);
  }
}

export function* watchGetSubscriptions() {
  yield takeLatest(actionTypes.GET_SUBSCRIPTIONS.ACTION, getSubscriptions);
}

export function* watchGetCurrentUserInit() {
  yield takeLatest(actionTypes.GET_CURRENT_USER_INIT.ACTION, getCurrentUserInit);
}

export function* watchGetSettings() {
  yield takeLatest(actionTypes.GET_SETTINGS.ACTION, getSettings);
}

export function* watchCreateAccount() {
  yield takeLatest(actionTypes.CREATE_ACCOUNT.ACTION, createAccount);
}

export function* watchCreateAccountForPublicOrg() {
  yield takeLatest(actionTypes.CREATE_ACCOUNT_FOR_PUBLIC_ORG.ACTION, createAccountForPublicOrg);
}

export function* watchWithinGeoFence() {
  yield takeLatest(actionTypes.WITHINGEOFENCE.ACTION, withinGeoFence);
}

export function* watchGetPrivateUserInfo() {
  yield takeLatest(actionTypes.GETPRIVATEUSERINFO.ACTION, getPrivateUserInfo);
}

export function* watchGetAsIsState() {
  yield takeLatest(actionTypes.MAP_PHONE_TO_SUBMIT.ACTION, getAsIsState);
}

export function* fetchCountries() {
  try {
    const url = `/rest/init/countries?orgId=${orgId}`;
    const { data: countryData } = yield call(Ajax.get, url);
    yield put(signUpActions.fetchCountries.success({ countryData }));
  } catch (error) {
    yield put(signUpActions.fetchCountries.fail(error));
  }
}

export function* watchFetchCountries() {
  yield takeLatest(actionTypes.FETCH_COUNTRIES.ACTION, fetchCountries);
}

export function* fetchLanguageSettings() {
  try {
    const url = `/mbr-portal/api/v1/getPreferredLanguageSetting?organizationId=${orgId}`;
    const { data: languageSettings } = yield call(Ajax.get, url);
    yield put(signUpActions.fetchLanguageSettings.success({ languageSettings }));
  } catch (error) {
    yield put(signUpActions.fetchLanguageSettings.fail(error));
  }
}
export function* watchFetchLanguageSettings() {
  yield takeLatest(actionTypes.FETCH_LANGUAGE_SETTINGS.ACTION, fetchLanguageSettings);
}

export function* fetchPublicProfile({ payload: { data, callback } }) {
  try {
    const token = getParam('token');
    console.log('token', token)
    if (token.trim().length != 0) {
      const url = `/mbr-portal/api/v1/getPublicProfile?token=${token}`;
      const { data: publicProfileInfo, status, errorCode } = yield call(Ajax.get, url, data);
      const isPublicProfile = false;
      console.log(publicProfileInfo, status)
      if (status === 200) {
        yield put(signUpActions.fetchPublicProfile.success({ publicProfileInfo, isPublicProfile }));
        callback();
      } else if (status === 404 || status === 400) {
        yield put(signUpActions.fetchPublicProfile.fail({ fetchPublicProfileError: 'Failed to get public user information' }));
        callback();
      } else {
        yield put(signUpActions.fetchPublicProfile.fail({ fetchPublicProfileError: errorCode }));
        callback();
      }
    } else {
      yield put(signUpActions.fetchPublicProfile.fail({ fetchPublicProfileError: 'token not found' }));
    }
  } catch (error) {
    yield put(signUpActions.getPrivateUserInfo.fail({ errorinfo: 'fetchPublicProfileError' }));
  }
}

export function* watchFetchPublicProfile() {
  yield takeLatest(actionTypes.FETCH_PUBLIC_PROFILE.ACTION, fetchPublicProfile);
}
